export default __webpack_public_path__ + "static/media/ae.60b603e4.svg";